module.exports = __webpack_public_path__ + "img/avatar-drinking-liquor.f2b2d0db.png";